<div
  (click)="navigateToDetails()"
  class="resource-card-wrapper"
>
  <div class="image-wrapper w-full flex justify-center">
    <app-image
      [url]="resource?.imgUrl || resource?.imageUrl | cdnBaseUrl"
      alt=""
    ></app-image>
  </div>
  <div class="w-full flex flex-col items-center">
    <div class="title-section w-[90%]">
      <p class="w-full title-content">
        {{ resource?.title }}
      </p>
    </div>
    <div class="description-section w-[90%]">
      <p class="w-full description-content">
        {{ resource?.description }}
      </p>
    </div>
    <div class="date-status-section flex justify-between w-[90%]">
      <div *ngIf="loggedInUserRole === allRoles.superAdmin"
           class="date-section">
        {{resource?.statusName}}
      </div>
    </div>
  </div>
</div>
